const d3 = Object.assign({}, require("d3-selection"), require("d3-array"))

export function prepareData() {

    // PART A : GET TOP X tag tiles
    // Flatten tags
    const tagArray = []
    this.dataset.forEach((d, i) => {
        const tags = d.tags
        const id = d.id
        // All all elements used for image gallery
        const width = d.width
        const height = d.height
        const color = d.color
        const user = d.user
        const urls = d.urls
        tags.forEach((tag, i) => {
            if (i < this.maxTagsPerPhoto) {
                let element = {}
                element.id = id
                element.width = width
                element.height = height
                element.color = color
                element.user = user
                element.urls = urls
                element.tag = tag.title
                tagArray.push(element)
            }
        })
    })
    this.tagArray = tagArray

    const tagData = d3.rollup(tagArray, v => v.length, this.dataAccessor)
    let tagSortAll = Array.from(tagData)
        .slice()
        .sort((a, b) => d3.descending(a[1], b[1]))
        .filter(tag => tag[1] >= this.minCount)

    let tagSort = tagSortAll.slice(
        this.startIndex,
        this.startIndex + this.topTags
    )

    this.tagAmount = tagSort
    this.tagCount = tagSort.length
    this.tagAll = tagSortAll

    const tagMatch = []
    tagSort.forEach((d, i) => {
        tagMatch.push(d[0])
    })
    this.selectedTags = tagMatch

    // console.log(tagMatch)
    // PART B : CREATE MATRIX

    let dataTagArray = [] // tags per photo
    let tagMatrix = [] // matrix per photo
    let matrix = [] // matrix of all photos

    this.dataset.forEach((d, i) => {
        dataTagArray = [] // empty for each iteration
        tagMatch.forEach(d => {
            const myMatch = this.dataset[i].tags.find(tag => tag.title === d)
            if (myMatch) {
                dataTagArray.push(myMatch.title)
            } else {
                dataTagArray.push("")
            }
        })

        tagMatrix = dataTagArray.map((col, i) => {
            return dataTagArray.map((row, x) => {
                if (row === col || row === "" || col === "") {
                    // console.log(`0 --- col: ${col} |  i: ${i} | row: ${row} | x: ${x}`)
                    return 0
                } else {
                    return 1
                }
            })
        })

        // C: Add matrix to master matrix
        if (i === 0) {
            matrix = matrixAddition(tagMatrix, tagMatrix)
        } else {
            matrix = matrixAddition(matrix, tagMatrix)
        }
    })

    // D: Print matrix
    this.matrix = matrix

    function matrixAddition(a, b) {
        return a.map((n, i) => {
            return n.map((o, j) => {
                return o + b[i][j]
            })
        })
    }
}

export default prepareData
